import {
  differenceInCalendarDays,
  differenceInHours,
  differenceInMinutes,
  format,
  parseISO,
  isValid,
  parse,
} from 'date-fns'
import { TZDate } from '@date-fns/tz'

const vietnamTz = 'Asia/Bangkok'

export const formatDay = (date, st) => {
  if (!date) return ''
  return format(new TZDate(date, vietnamTz), st || 'dd/MM/yyyy')
}

export const formatDayWithTime = (date) => {
  if (!date) return ''
  return format(new TZDate(date, vietnamTz), 'dd/MM/yyyy HH:mm')
}
export const formatDayWithTimeSecond = (date) => {
  if (!date) return ''
  return format(new TZDate(date, vietnamTz), 'dd/MM/yyyy HH:mm:ss')
}

export const formatSecond = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  // Pad hours, minutes, and seconds with leading zeros if necessary
  const formattedHours = String(hours).padStart(2, '0')
  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSeconds).padStart(2, '0')

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
}

export const formatDob = (dob, formatStr = 'yyyy-MM-dd') => {
  const dobDate = parseISO(dob, 'yyyy-MM-dd', new Date())
  return format(dobDate, formatStr)
}

export const getVNDate = (date) => new TZDate(date, vietnamTz)

export const mapMonthContext = (month) => {
  const map = {
    0: 'Tháng 1',
    1: 'Tháng 2',
    2: 'Tháng 3',
    3: 'Tháng 4',
    4: 'Tháng 5',
    5: 'Tháng 6',
    6: 'Tháng 7',
    7: 'Tháng 8',
    8: 'Tháng 9',
    9: 'Tháng 10',
    10: 'Tháng 11',
    11: 'Tháng 12',
  }
  return map[Number(month)]
}

export const generateLastMsgTimeText = (time) => {
  if (!time) return ''
  const currentTime = getVNDate(new Date())
  const datedLastMsgTime = getVNDate(time)
  const diffDays = differenceInCalendarDays(currentTime, datedLastMsgTime)
  const diffHours = differenceInHours(currentTime, datedLastMsgTime)
  const diffMinutes = differenceInMinutes(currentTime, datedLastMsgTime)

  if (diffDays === 0) {
    if (diffHours === 0) {
      if (diffMinutes === 0) {
        return 'Vừa xong'
      } else {
        return diffMinutes + ' phút trước'
      }
    } else if (diffHours === 1) {
      return '1 giờ trước'
    } else if (diffHours === 2) {
      return '2 giờ trước'
    } else {
      return 'Hôm nay ' + format(datedLastMsgTime, 'HH:mm')
    }
  } else if (diffDays === 1) {
    return 'Hôm qua ' + format(datedLastMsgTime, 'HH:mm')
  } else {
    return format(datedLastMsgTime, 'dd/MM/yyyy HH:mm')
  }
}

export function formatIfDate(value) {
  if (typeof value !== 'string') return value
  let parsedDate = null

  const customFormatRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/
  if (customFormatRegex.test(value)) {
    parsedDate = parse(value, 'yyyy-MM-dd HH:mm:ss', new Date())
  } else if (!isNaN(Date.parse(value))) {
    parsedDate = parseISO(value)
  }

  if (parsedDate && isValid(parsedDate)) {
    return format(parsedDate, 'dd/MM/yyyy HH:mm')
  }

  return value
}
